import { Select, ISelect } from "./";
import { textChooser } from "../../../util/textChooser";
import { useEffect, useState } from "react";
import { getGraduations } from "../../../apis/public.api";
import { formatValuesForSelect } from "../../../helpers/utilities";

interface GradesProps extends ISelect {}

export const Grades = (props: GradesProps) => {

    const [grades, setGrades] = useState([]);

    useEffect(() => {
        getGraduations().then((gradesData) => {
            formatValuesForSelect(setGrades, gradesData)
        })
    }, [])
    
    return(
        <Select 
            {...props} 
            label={props?.label ?? textChooser("txt114")}
            currentValue={props.currentValue} 
            values={grades}
        />
    )
}